import type { SwingInputSnapshot } from './SwingInput';

export class SwingDebugOverlay {
  private readonly element: HTMLDivElement;
  private readonly svg: SVGSVGElement;
  private readonly label: HTMLDivElement;

  constructor(container: HTMLElement) {
    this.element = document.createElement('div');
    this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    this.label = document.createElement('div');

    this.element.style.position = 'absolute';
    this.element.style.inset = '0';
    this.element.style.pointerEvents = 'none';
    this.element.style.display = 'none';
    this.element.style.touchAction = 'none';
    this.svg.style.position = 'absolute';
    this.svg.style.inset = '0';
    this.svg.style.width = '100%';
    this.svg.style.height = '100%';
    this.label.style.position = 'absolute';
    this.label.style.left = '50%';
    this.label.style.right = 'auto';
    this.label.style.bottom = 'calc(158px + env(safe-area-inset-bottom))';
    this.label.style.transform = 'translateX(-50%)';
    this.label.style.padding = '9px 12px';
    this.label.style.borderRadius = '10px';
    this.label.style.background = 'rgba(0, 8, 12, 0.78)';
    this.label.style.color = '#fff';
    this.label.style.font = '900 14px system-ui, sans-serif';
    this.element.append(this.svg, this.label);
    container.appendChild(this.element);
  }

  update(snapshot: SwingInputSnapshot): void {
    const active = snapshot.state !== 'IDLE' && snapshot.state !== 'COMPLETE';
    this.element.style.display = active ? 'block' : 'none';
    if (!active) return;

    this.svg.replaceChildren();
    if (snapshot.path.length > 1) {
      const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
      polyline.setAttribute(
        'points',
        snapshot.path.map((point) => `${point.x},${point.y}`).join(' '),
      );
      polyline.setAttribute('fill', 'none');
      polyline.setAttribute('stroke', '#f7e46c');
      polyline.setAttribute('stroke-width', '4');
      polyline.setAttribute('stroke-linecap', 'round');
      polyline.setAttribute('stroke-linejoin', 'round');
      this.svg.appendChild(polyline);
    }
    if (snapshot.impactPoint) {
      const impact = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      impact.setAttribute('cx', String(snapshot.impactPoint.x));
      impact.setAttribute('cy', String(snapshot.impactPoint.y));
      impact.setAttribute('r', '10');
      impact.setAttribute('fill', 'rgba(255, 255, 255, 0.9)');
      impact.setAttribute('stroke', '#1d5428');
      impact.setAttribute('stroke-width', '3');
      this.svg.appendChild(impact);
    }
    this.label.textContent = `Power ${snapshot.backswingPercent}%`;
  }

  dispose(): void {
    this.element.remove();
  }
}
